import useMedicalResultsActions from "../../../../../../components/medical-results/useMedicalResultsActions";

export default function useLaboratoryExamsActions({ subTabExamsLaboratory, onChange, appointmentId, patientId, isPageModalHistory, otherResultRecords }) {
  return useMedicalResultsActions({
    options: subTabExamsLaboratory?.optionsLaboratoryServices,
    records: subTabExamsLaboratory?.appointmentHistoryLaboratory,
    onChange, appointmentId, patientId, isPageModalHistory,
    subTabKey: "subTabExamsLaboratory",
    recordsKey: "appointmentHistoryLaboratory",
    examIdField: "laboratoryExamId",
    examField: "laboratoryExam",
    examHeader: "Examen de Laboratorio",
    resultName: "Resultados de Laboratorio",
    endpointName: "laboratory-result",
    otherResultRecords,
  });
}
